"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saleAgreement = void 0;
var utils_1 = require("../../utils");
exports.saleAgreement = function (axios) {
    return {
        GetSaleAgreementsmallProductNoView: function (request) {
            var url = utils_1.paramPathchange('/sale-agreements/{mallProductNo}/view', request);
            return axios.get(url, request);
        },
        GetSaleAgreementsmallProductNoHistories: function (request) {
            var url = utils_1.paramPathchange('/sale-agreements/{mallProductNo}/histories', request);
            return axios.get(url, request);
        },
        /** 상품 판매합의 히스토리 상세 조회 API */
        GetSaleAgreementHistoriesSaleAgreementSeqView: function (request) {
            var url = utils_1.paramPathchange('/sale-agreements/histories/{saleAgreementSeq}/view', request);
            return axios.get(url, request);
        },
        getSaleAgreements: function (getSaleAgreementsRequest) {
            return axios.get('/sale-agreements', getSaleAgreementsRequest);
        },
        getSaleAgreementCount: function () {
            return axios.get('/sale-agreements/count');
        },
        getSaleAgreementsExcel: function (getSaleAgreementsExcelRequest) {
            return axios.get('/sale-agreements/excel', getSaleAgreementsExcelRequest);
        },
        putSaleAgreementsMallProductNo: function (putSaleAgreementsMallProductNoRequest) {
            var url = utils_1.paramPathchange('/sale-agreements/{mallProductNo}', putSaleAgreementsMallProductNoRequest);
            return axios.put(url, putSaleAgreementsMallProductNoRequest.data);
        },
        /** 글로벌 상품 판매합의 합의/거절 */
        putSaleAgreementsGlobalGlobalProductNo: function (request) {
            var url = utils_1.paramPathchange('/sale-agreements/global/{globalProductNo}', request);
            return axios.put(url, request.data);
        },
        /** 글로벌 상품 판매합의 히스토리 조회 */
        getSaleAgreementsGlobalGlobalProductNoHistories: function (request) {
            var url = utils_1.paramPathchange('/sale-agreements/global/{globalProductNo}/histories', request);
            return axios.get(url, request);
        },
        /** 글로벌 상품 판매합의 조회 */
        getSaleAgreementsGlobalGlobalProductNoView: function (request) {
            var url = utils_1.paramPathchange('/sale-agreements/global/{globalProductNo}/view', request);
            return axios.get(url, request);
        },
        /** 글로벌 상품판매합의 히스토리 상세 조회 */
        getSaleAgreementsGlobalGlobalProductNoHistoriesSaleAgreementSeqView: function (request) {
            var url = utils_1.paramPathchange('/sale-agreements/global/{globalProductNo}/histories/{saleAgreementSeq}/view', request);
            return axios.get(url, request);
        }
    };
};
